<template>
<div class="search_error">
    <div class="net_wrap" v-if="showNetErr">
        <img src="../../assets/images/parent-course/search-nodata.png" alt="searchNodata">
        <p>哎呀，网络开小差了~</p>
    </div>
</div>
</template>

<script>
export default {
  name: 'search-error',
  components: {},
  props: {
    showNetErr: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.search_error {
    .net_wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 234px;
        height: 225px;
        img {
            width: 100%;
            p {
                height: 20px;
                line-height: 20px;
                color: #000;
                font-size: 14px;
            }
        }
    }
}
</style>
